<template>
  <!-- <div class="order-item">
    <div class="item-top">
      <div class="top-left">
        <p class="order-date">订单日期：2019-7-8</p>
        <p class="order-no">订单号：324234</p>
      </div>
      <div class="top-right">状态</div>
    </div>
    <div style="height:40px;"></div>
    <div class="item-bottom">金额</div>
  </div>-->
  <div class="order-info">
    <router-link :to="'/order/detail/'+info.OrderNo">
      <van-panel :title="info.CreateTime" :desc="'订单号：'+info.OrderNo" :status="statusText">
        <div class="goods-list">
          <div class="goods-box van-hairline--bottom" v-for="item in info.Products" :key="item.Id">
            <div class="image">
              <img :src="item.ProductImage" v-lazy="item.ProductImage" alt />
            </div>
            <div class="info">
              <div class="info-item">
                <div class="info-item-left">
                  <span class="p-title">{{item.ProductTitle}}</span>
                </div>
                <div class="info-item-right">
                  <span>￥{{item.Price}}</span>
                </div>
              </div>
              <div class="info-item">
                <div class="info-item-left">
                  <span class="sku-f">{{item.StockTitle}}</span>
                </div>
                <div class="info-item-right">
                  <span class="sku-f">x {{item.Count}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="sum-price">
            <van-row>
              <van-col span="12" class="order-tags">
                <van-tag plain type="primary" v-if="info.SelfPickup">自提</van-tag>
              </van-col>
              <van-col span="12">合计金额：{{info.TotalAmount | num2Filter}}</van-col>
            </van-row>
          </div>
          <van-button
            v-if="info.OrderStatus===4 || info.OrderStatus===5"
            size="small"
            round
            @click.stop.prevent="deleteOrder(info.OrderNo)"
          >删除订单</van-button>
          <van-button
            v-if="info.OrderStatus===1"
            size="small"
            round
            @click.stop.prevent="cancelOrder(info.OrderNo)"
          >取消订单</van-button>
          <van-button
            v-if="info.OrderStatus===1 && info.OrderType===1 && !isExpire"
            size="small"
            round
            type="primary"
            :loading="payment"
            loading-text="去支付…"
            @click.stop.prevent="continuePay(info.OrderNo)"
          >继续支付</van-button>
        </div>
      </van-panel>
    </router-link>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "OrderItem",
  props: {
    info: {}
  },
  data() {
    return {
      payment: false,
      te: {
        OrderNo: "201907031500002",
        TotalAmount: 30.0,
        ProductAmount: 20.0,
        ExpressFee: 10.0,
        ProductCount: 1,
        CreateTime: "2019-07-03 15:59:17",
        ExpireTime: "2019-07-03 16:29:17",
        PayTime: null,
        OrderStatus: 4,
        OrderRemark: null,
        Recipient: "老白",
        AddressDetail: "北京市北京市东城区北池子大街67号",
        RecipientMobile: "18600000000",
        Products: [
          {
            Id: 54,
            OrderNo: "201907031500002",
            StockId: 1,
            StockTitle: "20元卡",
            ProductTitle: "蛋糕电子券",
            Count: 1,
            Price: 20.0,
            ProductType: 2,
            Status: 0
          }
        ]
      }
    };
  },
  computed: {
    //是否过期
    isExpire() {
      let exDate = new Date(this.info.ExpireTime);
      //console.log(new Date());
      if (this.info.OrderStatus === 1 && exDate < new Date()) {
        return true;
      } else return false;
    },
    statusText() {
      let txt = "";
      switch (this.info.OrderStatus) {
        case 1:
          txt = "待付款";
          break;
        case 2:
          txt = "已支付";
          break;
        case 3:
          txt = "已发货";
          break;
        case 4:
          txt = "已取消";
          break;
        case 5:
          txt = "已完成";
          break;
        case 6:
          txt = "已退款";
          break;
        default:
          txt = "";
          break;
      }
      if (this.info.OrderStatus === 1 && this.isExpire) {
        txt = "已超时";
      }
      return txt;
    }
  },
  methods: {
    getStatusText(status) {
      switch (status) {
        case 1:
          return "待付款";
        case 2:
          return "已支付";
        case 3:
          return "已发货";
        case 4:
          return "已取消";
        case 5:
          return "已完成";
        default:
          return "";
      }
    },
    onSelect(orderNo) {
      this.$router.push({ name: "orderView", props: { orderNo: orderNo } });
    },
    cancelOrder(orderNo) {
      Dialog.confirm({
        title: "取消订单",
        message: "确定要取消当前订单吗？"
      })
        .then(() => {
          //取消订单
          this.$ajax.post("/api/order/cancel/" + orderNo).then(response => {
            if (response.data.code === 1) {
              //console.log(response.data.data);
              this.info.OrderStatus = response.data.data.OrderStatus;
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    deleteOrder(orderNo) {
      Dialog.confirm({
        title: "删除订单",
        message: "确定要删除此订单吗？"
      })
        .then(() => {
          //删除订单
          this.$ajax.post("/api/order/delete/" + orderNo).then(response => {
            if (response.data.code === 1) {
              //console.log(response.data.data);
              //this.info.OrderStatus = response.data.data.OrderStatus;
              this.$destroy();
              this.$el.parentNode.removeChild(this.$el);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    continuePay(orderNo) {
      //继续支付
      console.log(orderNo);
      this.payment = true;
      this.$toast.loading({
        mask: true,
        message: "跳转支付",
        forbidClick: true
      });
      this.$ajax.post("/api/order/pay/" + orderNo).then(response => {
        if (response.data.code === 1) {
          var data = response.data.data;
          if (data.PayUrl !== "") {
            window.location.href = data.PayUrl;
          }
        } else {
          //无法继续支付
          this.$toast("订单无法支付，请重新下单。");
        }
        this.payment = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/base-var.less";

.order-item {
  background-color: #fff;
  margin-top: 10px;
  padding: 0 15px;
}
.order-item .item-top {
  padding: 10px 0 6px;
  border-bottom: 1px solid #ececec;
  display: flex;
}
.order-item .item-bottom {
  padding: 10px 0;
  border-top: 1px solid #ececec;
  text-align: right;
}

.item-top .top-left {
  flex: 1;
}
.item-top .top-right {
  color: #ff4444;
}
.item-top .order-date {
  margin-bottom: 5px;
}
.item-top .order-no {
  color: #999;
  font-size: 14px;
}

.order-info {
  background-color: #fff;
  margin-top: 10px;
}
.order-info .van-panel__content {
  padding: 10px 15px;
}

.order-info .van-panel__footer {
  text-align: right;
}

.order-info .van-panel__footer button {
  margin-left: 10px;
}

.order-tags {
  text-align: left;
}
.sum-price {
  font-size: 12px;
  margin-bottom: 8px;
}

.goods-box {
  display: flex;
  background: #fff;
  padding: 5px 0;
  font-size: 14px;
}

.goods-box .image {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}
.goods-box .image img {
  max-width: 100%;
  border-radius: 4px;
}
.goods-box .info {
  flex: 1;
}
.info-item {
  display: flex;
  margin-bottom: 5px;
}
.info-item-right {
  width: 60px;
  text-align: right;
}
.info-item-left {
  flex: 1;
  text-align: left;
}
.p-title {
  font-weight: 500;
}
.p-price {
  color: #f44;
}
.sku-f {
  font-size: 12px;
  color: @gray-color;
}
.goods-list .goods-box:first-child {
  padding-top: 1px;
}
.goods-list .goods-box:last-child {
  padding-bottom: 0;
}
.goods-list .goods-box:last-child::after {
  border-bottom-width: 0px;
}
</style>